import * as React from 'react';
import {observer,inject} from 'mobx-react';
import {IStores,IStoresInject} from '../../../../../../Types/interfaces';
import HdVector from '../../../../../SVG/Ratings/hd';
// ***********************************
interface IProps extends IStoresInject {active:boolean; vectorSize: number;}
@inject((stores: IStores): IStoresInject => ({...stores}))
@observer export default class HdIndicator extends React.Component<IProps,{}> {
  //***********************
  active: boolean;
  //***********************
  constructor(props: IProps) {
    super(props);
    const {siteSettings,active}=this.props;
    this.active=siteSettings!.detailFields.HDIndicator&&active;
  }
  //***********************
  render() {
    if(!this.active) { return (''); }
    const {vectorSize}=this.props;

    const ratingDivStyle={
      display: 'inline-block', 
      borderRadius:'3px', 
      marginRight:'4px', 
      height: vectorSize+'px', 
      width: vectorSize+'px'
    };

    return (
      <div style={ratingDivStyle}><HdVector size={vectorSize} /></div>
    );
  }
  //***********************
}
// ***********************************